export default __webpack_public_path__ + "/dist/images/settings-small.f69176a36a1aec273d89a5d22dd22d27.png";